import { render } from "./studioArticle.vue?vue&type=template&id=d3a13fc4&scoped=true"
import script from "./studioArticle.vue?vue&type=script&lang=js"
export * from "./studioArticle.vue?vue&type=script&lang=js"

import "./studioArticle.vue?vue&type=style&index=0&id=d3a13fc4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3a13fc4"]])

export default __exports__